export default {
  routes: [
    {
      name: 'responsibles',
      path: '/directory/responsibles',
      component: () => import('./views/TheResponsibles.vue'),

    },

    {
      name: 'responsible',
      path: '/directory/responsibles/:uuid',
      component: () => import('./views/TheResponsible.vue'),
    },
  ]
}
